var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-carousel",
        {
          staticStyle: { "text-shadow": "1px 1px 2px #333" },
          attrs: {
            id: "carousel-1",
            interval: 4000,
            controls: "",
            indicators: "",
            background: "#ababab",
            "img-width": "1024",
            "img-height": "480",
          },
          on: {
            "sliding-start": _vm.onSlideStart,
            "sliding-end": _vm.onSlideEnd,
          },
          model: {
            value: _vm.slide,
            callback: function ($$v) {
              _vm.slide = $$v
            },
            expression: "slide",
          },
        },
        [
          _c("b-carousel-slide", { attrs: { "img-src": "/banner/1.webp" } }),
          _vm._v(" "),
          _c("b-carousel-slide", { attrs: { "img-src": "/banner/2.webp" } }),
          _vm._v(" "),
          _c("b-carousel-slide", { attrs: { "img-src": "/banner/3.webp" } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }